import React from 'react';
import { Box, Heading, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const FAQ = () => {
  const { t } = useTranslation();

  const questions = [
    { id: 1, question: t('faq_p1_q'), answer: t('faq_p1_a') },
    { id: 2, question: t('faq_p2_q'), answer: t('faq_p2_a') },
    { id: 3, question: t('faq_p3_q'), answer: t('faq_p3_a') },
    { id: 4, question: t('faq_p4_q'), answer: t('faq_p4_a') },
    { id: 5, question: t('faq_p5_q'), answer: t('faq_p5_a') },
    { id: 6, question: t('faq_p6_q'), answer: t('faq_p6_a') },
    { id: 7, question: t('faq_p7_q'), answer: t('faq_p7_a') },
  ];

  return (
    <Box p={4}>
      <Heading as="h2" size="lg" mb={4}>
        {t('faq_title')}
      </Heading>
      <VStack spacing={4} align="stretch">
        {questions.map((item) => (
          <Box
            key={item.id}
            p={4}
            borderWidth="1px"
            borderRadius="md"
            shadow="sm"
          >
            <Heading as="h3" size="md" mb={2}>
              {item.question}
            </Heading>
            <Text>{item.answer}</Text>
          </Box>
        ))}
      </VStack>
    </Box>
  );
};

export default FAQ;
